import { BREAKPOINTS } from '@depop/web-thrift-ui/theme/default/breakpoints.constants';

export const MOBILE_MEDIA_QUERY = `(max-width: ${BREAKPOINTS.LG_MAX_PX})`;
